import React from 'react';

import styled from 'styled-components';

import { TotemLabel } from '../TotemLabel';

/**
 * Lien vers une ressource HORS totadmin (Odoo, Stripe, Ava…), au même gabarit que `DetailValue` et
 * `DetailLink`. `DetailLink` passe par le routeur react-router et ne sait pas sortir de l'app ; le
 * motif « ancre + logo » vivait jusqu'ici recopié en styled-components dans chaque page de détails.
 */
export const DetailExternalLink = ({
    label,
    sublabel,
    href,
    name,
    iconSrc,
    iconAlt,
    emptyLabel = 'Non disponible',
    dataTest,
}: {
    label?: string;
    sublabel?: string;
    href?: string | null;
    name?: string | null;
    iconSrc?: string;
    iconAlt?: string;
    emptyLabel?: string;
    dataTest?: string;
}) => {
    return (
        <Container>
            <TotemLabel>{label}</TotemLabel>
            {sublabel ? <Sublabel>{sublabel}</Sublabel> : null}
            {href ? (
                <StyledLink href={href} target="_blank" rel="noopener noreferrer" data-test={dataTest}>
                    {iconSrc ? <Icon src={iconSrc} alt={iconAlt ?? ''} /> : null}
                    <span>{name ?? href}</span>
                </StyledLink>
            ) : (
                <EmptyValue data-test={dataTest}>{emptyLabel}</EmptyValue>
            )}
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    color: ${({ theme }) => theme.textColor};
`;

const Sublabel = styled.span`
    color: ${({ theme }) => theme.infoTextColor};
    font-size: 13px;
`;

const StyledLink = styled.a`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 5px;

    color: ${({ theme }) => theme.ctaPrimaryColor};
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }

    & > :not(:first-child) {
        margin-left: 10px;
    }
`;

const Icon = styled.img`
    width: 20px;
    height: 20px;
`;

const EmptyValue = styled.span`
    margin-top: 5px;
    color: ${({ theme }) => theme.infoTextColor};
`;
